import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { DumboProps } from './types';
import Hidden from './Hidden';
import Premium from './Premium';

export function useDumboCommon(props: DumboProps) {
  const { showBlocked } = useDeviationMatureFilter(props.deviation);

  if (!props.deviation) {
    return null;
  }

  if (showBlocked && !props.showMatureContent) {
    // most images are blurred on the backend
    // so no need to handle it differently (unless asked to force clientside handling)
    return !props.handleVisualBlockOnClientside ? null : <Hidden {...props} />;
  }

  const { isPremiumLocked } = normalizePremiumFolderData(props.deviation?.premiumFolderData);

  if (isPremiumLocked) {
    return <Premium {...props} />;
  }
}
